import { render, staticRenderFns } from "./DamageListItem.vue?vue&type=template&id=710392b0&scoped=true"
import script from "./DamageListItem.vue?vue&type=script&lang=ts"
export * from "./DamageListItem.vue?vue&type=script&lang=ts"
import style0 from "./DamageListItem.vue?vue&type=style&index=0&id=710392b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710392b0",
  null
  
)

export default component.exports